import { SharedMsgHelper } from './SharedMsgHelper';
import * as _ from 'lodash';
import dayjs from 'dayjs';

export const ValidationHelper = {
    getRequiredRule(): any {
        const rule: any = (value: string) => !!value || SharedMsgHelper.getMissingRequiredErrMsg;
        return rule;
    },
    getValidEmailRule(): any {
        const rule: any = (v: string) => /.+@.+\..+/.test(v) || SharedMsgHelper.getInvalidEmailErrMsg;
        return rule;
    },
    getValidPasswordRule(): any {
        const rule: any = (v: string) =>
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&^()\-_+])[A-Za-z\d@$!%*#?&^()\-_+]{8,}$/.test(v) ||
            SharedMsgHelper.getInvalidPasswordErrMsg;
        return rule;
    },
    getNotAllowWhitespaceRule(): any {
        const rule: any = (value: string) => /^\S*$/.test(value) || SharedMsgHelper.getNotAllowWhitespaceErrMsg;
        return rule;
    },
    isAlphanumericString(value: string): boolean {
        return /^[a-zA-Z0-9]*$/.test(value);
    },
    isValidCourierCode(code: string, courierCodeList: string[]): boolean {
        return _.indexOf(courierCodeList, code) >= 0;
    },
    isNumber(value: any): boolean {
        if (value === null || value === undefined || value === '') {
            return false;
        }
        return !isNaN(Number(value));
    },
    isInteger(value: any): boolean {
        if (value === null || value === undefined || value === '') {
            return false;
        }
        const num = Number(value);
        return !isNaN(num) && _.isInteger(num);
    },
    isStandardDateFormat(value: string): boolean {
        if (!value || value === '') {
            return false;
        }
        // Strict format check: must be exactly YYYY-MM-DD (zero-padded)
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            return false;
        }
        // Check if date is valid (handles leap years, invalid months/days)
        const parsed = dayjs(value, 'YYYY-MM-DD', true);
        if (!parsed.isValid()) {
            return false;
        }
        // Verify the parsed date matches input (prevents auto-correction like 2025-13-01 → 2026-01-01)
        return parsed.format('YYYY-MM-DD') === value;
    },
    isIsoUtcTimeString(value: string): boolean {
        if (!value || value === '') {
            return false;
        }
        // Strict format check: must match YYYY-MM-DDTHH:mm:ss.SSSZ
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value)) {
            return false;
        }
        return dayjs(value, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]', true).isValid();
    }
};
